export const NOMINATION_MODAL_QUERY_PARAM = 'beginNomination';

export const NOMINATION_SURVEY_FORM_ID = 't21c6rBB';

export const NOMINATION_BLOG_URL = 'https://bonusly.com/post/make-every-contribution-count-the-case-for-a-strong-nomination-program';
export const NOMINATION_HELP_URL = 'https://help.bonus.ly/en/articles/10672010-setting-up-nomination-periods';
